import { usePartnerId } from 'utils/routing/params.hooks'
import { usePartnerCallbackConfiguration } from 'domains/connect/api/callback-configuration/fetchPartnerCallbackConfigurations.hooks'

export const useCallbackConfigurations = () => {
  const partnerId = usePartnerId()
  return usePartnerCallbackConfiguration(partnerId)
}
